import { useEffect, useRef, useState } from 'react';
import './AuthButton.css';

const CLIENT_ID = "1034228451896-msgjqa08al4aq28j3g0outfum20mgkge.apps.googleusercontent.com";
const CLIENT_SECRET = "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";
const API_KEY = "AIzaSyAlSpsXrFF89vqmnJmtbVKUiwZBsvx3L7g";

const SCOPES =
  'https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/userinfo.profile';
const DISCOVERY_DOC = 'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest';

declare global {
  interface Window {
    gapi: typeof gapi;
    google: typeof google;
  }
}

export default function AuthButton() {
  const tokenClient = useRef<google.accounts.oauth2.TokenClient | null>(null);
  const [gapiLoaded, setGapiLoaded] = useState(false);
  const [gisLoaded, setGisLoaded] = useState(false);
  const [profilePic, setProfilePic] = useState<string | null>(null);

  // Load gapi
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.onload = () => {
      window.gapi.load('client', async () => {
        await window.gapi.client.init({
          apiKey: API_KEY,
          discoveryDocs: [DISCOVERY_DOC],
        });
        setGapiLoaded(true);
      });
    };
    document.body.appendChild(script);
  }, []);

  // Load GIS
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.onload = () => {
      tokenClient.current = window.google.accounts.oauth2.initTokenClient({
        client_id: CLIENT_ID,
        scope: SCOPES,
        callback: async (tokenResponse) => {
          if (tokenResponse.error) {
            console.error('OAuth error:', tokenResponse);
            return;
          }
          await fetchUserProfile(tokenResponse.access_token);
          await fetchCalendarEvents();
        },
      });
      setGisLoaded(true);
    };
    document.body.appendChild(script);
  }, []);

  // Try silent login on load
  useEffect(() => {
    if (gapiLoaded && gisLoaded && tokenClient.current) {
      (tokenClient.current as any).callback = async (tokenResponse:any) => { //TODO: Fix type
        if (tokenResponse.error) {
          console.warn('Silent auth failed:', tokenResponse);
          return;
        }
        await fetchUserProfile(tokenResponse.access_token);
        await fetchCalendarEvents();
      };
      tokenClient.current.requestAccessToken({ prompt: '' });
    }
  }, [gapiLoaded, gisLoaded]);

  const handleAuthClick = () => {
    if (tokenClient.current) {
      (tokenClient.current as any).callback = async (tokenResponse:any) => { //TODO: Fix type
        if (tokenResponse.error) {
          console.error('OAuth error:', tokenResponse);
          return;
        }
        await fetchUserProfile(tokenResponse.access_token);
        await fetchCalendarEvents();
      };
      tokenClient.current.requestAccessToken({ prompt: 'consent' });
    }
  };

  const handleLogout = () => {
    const token = window.gapi.client.getToken();
    if (token?.access_token) {
      fetch(`https://oauth2.googleapis.com/revoke?token=${token.access_token}`, {
        method: 'POST',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded',
        },
      })
        .then(() => {
          window.gapi.client.setToken(null); // clear stored token
          setProfilePic(null); // reset UI state
          console.log('User logged out.');
        })
        .catch((err) => {
          console.error('Logout failed:', err);
        });
    }
  };

  const fetchUserProfile = async (accessToken: string) => {
    const response = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    const data = await response.json();
    setProfilePic(data.picture);
  };

  const fetchCalendarEvents = async () => {
    try {
      const response = await window.gapi.client.calendar.events.list({
        calendarId: 'primary',
        timeMin: new Date().toISOString(),
        showDeleted: false,
        singleEvents: true,
        maxResults: 10,
        orderBy: 'startTime',
      });

      const events = response.result.items;
      console.log('Upcoming events:');
      events?.forEach((event) => {
        const when = event.start?.dateTime || event.start?.date;
        console.log(`${event.summary} (${when})`);
      });
    } catch (err) {
      console.error('Error fetching events', err);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <button
        onClick={handleAuthClick}
        disabled={!(gapiLoaded && gisLoaded)}
        className="google-button"
      >
        {profilePic ? (
          <img src={profilePic} alt="Profile" className="google-avatar" />
        ) : (
          <span>Sign in with Google</span>
        )}
      </button>

      {profilePic && (
        <button onClick={handleLogout} className="logout-button">
          Logout
        </button>
      )}
    </div>
  );
}
